import React from 'react'
import GatsbyConfig from '../../../gatsby-config.js'
import {
  getEl,
  getEls,
  formatPrice,
  getRoomPrice,
  getParamFromQueryString,
  getInLocal,
  setInLocal,
  getValidCoupon,
} from '../../utils/app-helpers'
import moment from 'moment'
import get from 'lodash.get'

const { siteMetadata: config } = GatsbyConfig

export default class TripSummary extends React.Component {
  handleToggleClick = proxy => {
    const tripData = config.trips[this.props.trip]
    if (!tripData.allowPayChangeDuringCheckout) return
    const { target } = proxy
    const wrapperEl = getEl('.summary')
    const pay = target.getAttribute('data-pay')

    this.data = { ...(this.data || {}), pay }
    getEls('.price-toggle .btn').forEach(btnEl => {
      btnEl.classList.remove('checked')
    })
    target.classList.add('checked')
    wrapperEl.classList.remove('full', 'monthly')
    wrapperEl.classList.add(pay)
    setInLocal('lsg.book-data', JSON.stringify(this.data))
    getEl('.price-box .price').innerText = this.getFormattedPrice()
  }

  getFormattedPrice() {
    if (typeof window === 'undefined') return
    const { data, xMonths } = this
    const { room, trip } = this.props
    const tripData = config.trips[trip]
    const subscriptionFee = tripData.subscriptionFee * 100
    const perPersonFees = tripData.taxesAndFees * 100
    const price = getRoomPrice(tripData, room, data.promo)
    const priceFull = price * 100
    const priceMonthly = Math.round((priceFull + subscriptionFee) / xMonths)
    const pay = get(
      data,
      'pay',
      getParamFromQueryString('pay', window.location.href)
    )

    this.subscriptionFee = subscriptionFee
    this.perPersonFees = perPersonFees
    this.pricePerPerson = (price - tripData.taxesAndFees) / 0.02
    this.priceFull = priceFull
    this.priceMonthly = priceMonthly
    return pay === 'full'
      ? formatPrice(priceFull)
      : formatPrice(priceMonthly, '/mo')
  }

  render() {
    if (typeof window === 'undefined') return <div />
    const { room, trip, isPaid } = this.props
    const data = getInLocal(
      isPaid ? 'lsg.book-data-confirmed' : 'lsg.book-data',
      true
    )
    this.data = data
    const tripData = config.trips[trip]
    const matchedCoupon = tripData.useCoupons
      ? getValidCoupon(data.coupon, tripData.coupons)
      : null
    const couponValue = matchedCoupon ? matchedCoupon.value : '$0'
    const useMaxSubMonthsCutoff = moment(
      tripData.useMaxSubMonthsCutoff,
      'MM-DD-YYYY'
    )
    const availabilityCutoff = moment(tripData.availabilityCutoff, 'MM-DD-YYYY')
    const today = moment(new Date())
    const maxMonths = tripData.maxSubMonths
    let roomCards = []
    let xMonths

    if (today.valueOf() > useMaxSubMonthsCutoff.valueOf()) {
      let monthRemainder = 0
      xMonths = Math.floor(availabilityCutoff.diff(today, 'months', true)) + 1
      if (xMonths > maxMonths) {
        monthRemainder = xMonths - maxMonths
        xMonths = maxMonths
      }
      if (availabilityCutoff.date() > today.date()) {
        monthRemainder++
      }
    } else {
      xMonths = maxMonths
    }
    this.xMonths = xMonths

    const formattedPrice = this.getFormattedPrice()
    const { priceFull, priceMonthly, perPersonFees, pricePerPerson } = this
    const pay = get(
      data,
      'pay',
      getParamFromQueryString('pay', window.location.href)
    )

    let discountFull = ''
    let discountMonthly = ''
    if (matchedCoupon && couponValue.match('%')) {
      const percent = parseInt(couponValue.replace(/\D/g, ''), 10) / 100
      discountFull = priceFull * percent
      discountMonthly = priceMonthly * percent
    } else if (matchedCoupon && couponValue.match('$')) {
      discountFull = parseInt(couponValue.replace(/\D/g, ''), 10) * 100
      discountMonthly = discountFull / xMonths
    }

    return (
      <div className={`summary ${pay}`}>
        {isPaid ? (
          ''
        ) : (
          <span className="row">
            <span>
              <span className="trip">
                {tripData.name} {tripData.year}
              </span>
              &nbsp;|&nbsp;
              <span className="room">{room.name}</span>
            </span>
            <span className="price-box">
              <span className="price">{formattedPrice}</span>
              <span
                className={`price-toggle${
                  tripData.allowPayChangeDuringCheckout ? '' : ' immutable'
                }`}
              >
                <a
                  data-pay="full"
                  className={`btn check${pay === 'full' ? ' checked' : ''}`}
                  onClick={this.handleToggleClick.bind(this)}
                >
                  Pay in Full
                </a>
                {!tripData.disableMonthlyPaymentOption && (
                  <a
                    data-pay="monthly"
                    className={`btn check${pay === 'monthly' ? ' checked' : ''}`}
                    onClick={this.handleToggleClick.bind(this)}
                  >
                    For {xMonths} Months
                  </a>
                )}
              </span>
            </span>
          </span>
        )}
        <dl className="full">
          <dt>Pay-in-Full Price (${pricePerPerson / 100} per person)</dt>
          <dd>{formatPrice(pricePerPerson * 2)}</dd>
        </dl>
        <dl className="full">
          <dt>Taxes and Fees (${perPersonFees / 200} per person)</dt>
          <dd>{formatPrice(perPersonFees)}</dd>
        </dl>
        {matchedCoupon &&
        discountFull && (
          <dl className="full">
            <dt>
              Promo Code "{data.coupon}" ({couponValue} OFF!)
            </dt>
            <dd>{formatPrice(-discountFull)}</dd>
          </dl>
        )}
        <dl className="full total">
          <dt>{isPaid ? 'Total Paid' : 'Total Charges'}</dt>
          <dd>{formatPrice(priceFull - discountFull)}</dd>
        </dl>
        <dl className="monthly">
          <dt>
            Monthly Recurring Payments (
            {formatPrice(priceMonthly / 2)} per person x 2 for {xMonths} months)
          </dt>
          <dd>{formatPrice(priceMonthly)}</dd>
        </dl>
        {matchedCoupon &&
          discountMonthly && (
            <dl className="monthly">
              <dt>
                Promo Code "{data.coupon}" ({couponValue} / {xMonths} months)
              </dt>
              <dd>{formatPrice(-discountMonthly)}</dd>
            </dl>
          )}
        <dl className="monthly">
          <dt>Taxes and Fees (${perPersonFees / 200} per person)</dt>
          <dd>Included</dd>
        </dl>
        <dl className="monthly total">
          <dt>{isPaid ? 'Total Per Month' : 'Total Due Today'}</dt>
          <dd>{formatPrice(priceMonthly - discountMonthly)}</dd>
        </dl>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/trip-summary.js